export * from "./collaborateLabels.actions";
export * from "./collaborateLabels.actionTypes";
export { default as reducer } from "./collaborateLabels.reducer";
export * from "./collaborateLabels.selectors";

export const MODULE = "collaborateLabels";
